import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Banner(props) {
  return (
    <div className="service_usa" style={{ backgroundColor: "#281d40" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <h1>
                <span>App Maintenance and Support</span> Services
              </h1>
              <p>
                Being a full-fledged app solution provider TekRevol specializes
                in complete app maintenance and support services. We never leave
                our clients clueless after the deployment of their applications.
                A steady app maintenance service is always by your side to
                ensure optimal performance, enabling you to sustain your
                business online.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Start Your App Maintenance
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-auto">
            <StaticImage
              src="../../images/services-usa/mobile-support/support-banner.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={776}
              height={667}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
